import { userRoles } from '../../../constants/userRoles';
import { LoggedInUser } from '../../../interfaces/LoggedInUser';

export const getUserName = (loggedInUser: LoggedInUser | null) => {
  if (!loggedInUser) {
    return null;
  }

  const { firstName, lastName, corporateAccountInfo, role } = loggedInUser;

  if (role === userRoles.ADMIN) {
    return loggedInUser.gymName;
  }

  if (!firstName && !lastName) {
    return corporateAccountInfo?.account_name;
  }

  const fullName = `${firstName || ''} ${lastName || ''}`.trim();

  return fullName;
};
